import useConfigValues from '../../ReduxFunctions/useConfigValues';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllData, fetchData, fetchUpdateData } from '../../Helpers/externapi';
import { setHospitalImage } from '../../ReduxFunctions/ReduxSlice';
import { logToCloudWatch } from '../../Helpers/cloudwatchLogger';

const useHomeController = () => {
    const configValues = useConfigValues('hospitalImagesURL', 'CardFront', 'CardBack', 'LogoWithoutName', 'couponAmount', 'ConsultationInvoiceBucketURL');
    const hospitalImage = useSelector((state) => state.hospitalImage);
    const dispatch = useDispatch();

    const [memberDetails, setMemberDetails] = useState();
    const [dependents, setDependents] = useState();
    const [isformOpen, setIsformOpen] = useState(false);
    const [formData, setFormData] = useState({
        FullName: '', MobileNumber: '', Cardnumber: '', Gender: '', DateofBirth: '', Age: '', Address: '', Appointment: '',
        DateAndTime: '', DoctorName: '', ServiceType: null, MemberDependentId: null, LabPercentage: null, PharmacyPercentage: null,
        PaidAmount: '', TotalAmount: ''
    });
    const [formErrors, setFormErrors] = useState({ DateAndTime: '', ServiceType: '', DoctorName: '' });
    const [eligibilityMessage, setEligibilityMessage] = useState();
    const [formSuccessMessage, setFormSuccessMessage] = useState();
    const [isValid, setIsValid] = useState(false);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [isFlipped, setIsFlipped] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [, setAvailableCoupons] = useState();
    const [displayCoupons, setDisplayCoupons] = useState(false);
    const [isBookingSuccess, setIsBookingSuccess] = useState(false);
    const [serviceTypes, setServiceTYpes] = useState([]);
    const [previousAppointments, setPreviousAppointments] = useState();
    const [service, setService] = useState('');
    const [servicesLoading, setServicesLoading] = useState(true);

    const [hospitalServices, setHospitalServices] = useState([]);

    const navigate = useNavigate();
    const memberId = sessionStorage.getItem('memberId');
    const hospitalId = sessionStorage.getItem('hospitalId');
    const hospitalName = sessionStorage.getItem('hospitalName');
    const hospitalLogo = sessionStorage.getItem('hospitalImage');
    const [frontCard, setFrontcard] = useState();
    const [backCard, setBackCard] = useState();
    const [logo, setLogo] = useState();
    const [amount, setAmount] = useState('');
    const [, setCouponCount] = useState(0);

    const [memberCoupons, setMemberCoupons] = useState({});
    const [dependentCoupons, setDependentCoupons] = useState({});
    const [selectedMemberType, setSelectedMemberType] = useState();
    const [bookingConsultationId, setBookingConsultationId] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [showInvoiceForm, setShowInvoiceForm] = useState(false);
    const [isSubmittingInvoice, setIsSubmittingInvoice] = useState(false);
    const [invoiceMap, setInvoiceMap] = useState({});
    const [invoiceUrl, setInvoiceUrl] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerCardNumber, setCustomerCardNumber] = useState('');





    const getLogStreamName = () => {
        const today = new Date().toISOString().split('T')[0];
        return `${hospitalId} (${hospitalName})-${today}`;
    };


    const [invoiceForm, setInvoiceForm] = useState({
        bookingConsultationId: '',
        customerId: '',
        dependentCustomerId: '',
        consultationFee: '',
        labInvestigationFee: '',
        pharmacyFee: '',
        otherCharges: '',
        discountPercentage: '',
        paidAmount: null,
    });



    const logGroupName = process.env.REACT_APP_LOGGER;
    const logStreamName = getLogStreamName();

    // const memberId = 25587;


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        };
        return date.toLocaleString('en-IN', options);
    };

    const getAvailableCoupons = useCallback(async (cardNumber, selectedHospitalId, selectedMemberId) => {
        const fetchAvailableCoupons = await fetchData('lambdaAPI/BookingConsultation/checkAvailableCoupons', {
            cardNumber,
            hospitalId: selectedHospitalId,
            customerId: selectedMemberId
        });

        setCouponCount(fetchAvailableCoupons.status ? fetchAvailableCoupons.availableCoupons : 0);

        if (fetchAvailableCoupons && fetchAvailableCoupons.status) {
            setAvailableCoupons(fetchAvailableCoupons.availableCoupons);
        } else {
            setAvailableCoupons();
        }
    }, []);


    useEffect(() => {
        if (!configValues.length) {
            return;
        }

        if (!hospitalImage.length) {
            const imageUrl = configValues.find(val => val.ConfigKey === "hospitalImagesURL");
            if (imageUrl && hospitalLogo) {
                dispatch(setHospitalImage(imageUrl.ConfigValue + hospitalLogo));
            }
        }

        const cardFront = configValues.find(val => val.ConfigKey === "CardFront");
        const cardBack = configValues.find(val => val.ConfigKey === "CardBack");
        const ohoLogo = configValues.find(val => val.ConfigKey === "LogoWithoutName");
        const profileUrl = configValues.find(value => value.ConfigKey === 'couponAmount');
        const invoiceURL = configValues.find(value => value.ConfigKey === 'ConsultationInvoiceBucketURL');

        setLogo(ohoLogo);
        setFrontcard(cardFront);
        setBackCard(cardBack);
        if (profileUrl) {
            setAmount(profileUrl.ConfigValue);
        }
        if (invoiceURL) {
            setInvoiceUrl(invoiceURL.ConfigValue);
        }
    }, [configValues, dispatch, hospitalImage, hospitalLogo]);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchMemberDetails = async () => {
            const responseMemberDetails = await fetchAllData(`lambdaAPI/OHOCards/GetMemberDetailsId/${memberId}`);
            setMemberDetails(responseMemberDetails);
            setIsDataFetched(true);
            if (responseMemberDetails && responseMemberDetails.length > 0) {
                setFormData((preVal) => ({
                    ...preVal, FullName: responseMemberDetails[0].FullName, MobileNumber: responseMemberDetails[0].MobileNumber, Cardnumber: responseMemberDetails[0].OHOCardNumber,
                    Gender: responseMemberDetails[0].Gender, DateofBirth: formatDate(responseMemberDetails[0].DateofBirth), Age: calculateAge(responseMemberDetails[0].DateofBirth),
                    Address: responseMemberDetails[0].AddressLine1
                }));
                getAvailableCoupons(responseMemberDetails[0].OHOCardNumber, hospitalId, memberId);
            }
        };

        const fetchDependents = async () => {
            const responseDependents = await fetchAllData(`lambdaAPI/Customer/GetDependentsByCustomerId/${memberId}`);
            setDependents(responseDependents);
        };





        const fetchServiceTypes = async () => {
            const getServiceTypes = await fetchData("HospitalServices/all", { skip: 0, take: 0 });
            setServiceTYpes(getServiceTypes);
        };

        const fetchHospitalServices = async () => {
            setServicesLoading(true);
            try {

                const servicesResponse = await fetchAllData(`HospitalPoliciesProvision/GetByHospitalId/${hospitalId}`);


                if (servicesResponse) {
                    setHospitalServices(servicesResponse || []);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setServicesLoading(false);
            }
        }

        fetchMemberDetails();
        fetchDependents();
        fetchServiceTypes();
        fetchHospitalServices();


    }, [getAvailableCoupons, hospitalId, memberId]);







    useEffect(() => {
        if (memberDetails && memberDetails.length > 0) {
            const inputDate = memberDetails[0].EndDate;
            const today = new Date();
            const parsedInputDate = new Date(inputDate);

            setIsValid(parsedInputDate > today);
        }
    }, [memberDetails])

    function calculateAge(dateOfBirth) {
        const dob = new Date(dateOfBirth);
        const today = new Date();

        let age = today.getFullYear() - dob.getFullYear();
        const monthDifference = today.getMonth() - dob.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
            age--;
        }

        return age;
    };

    const onChangeHandler = (e) => {

        if (e.target.name === 'FullName') {
            memberDetails[0].FullName === e.target.value ? (
                setFormData((preVal) => ({
                    ...preVal, FullName: memberDetails[0].FullName, MobileNumber: memberDetails[0].MobileNumber, Cardnumber: memberDetails[0].OHOCardNumber,
                    Gender: memberDetails[0].Gender, DateofBirth: formatDate(memberDetails[0].DateofBirth), Age: calculateAge(memberDetails[0].DateofBirth),
                    Address: memberDetails[0].AddressLine1
                }))
            ) : dependents.map(each => (
                each.name === e.target.value && (
                    setFormData((preVal) => ({
                        ...preVal, FullName: each.name, Gender: each.gender, DateofBirth: formatDate(each.dateofBirth), Age: calculateAge(each.dateofBirth),
                    }))
                )
            ))

            setFormData(preVal => ({
                ...preVal, [e.target.name]: e.target.value
            }))

        } else if (e.target.name === 'DoctorName') {
            setFormErrors(preVal => ({
                ...preVal, DoctorName: ''
            }));
            setFormData(preVal => ({
                ...preVal, [e.target.name]: e.target.value
            }));
        } else if (e.target.name === 'ServiceType') {
            setFormData(preVal => ({
                ...preVal, [e.target.name]: parseInt(e.target.value)
            }))
            if (e.target.value.length > 0) {
                setFormErrors(preVal => ({
                    ...preVal, [e.target.name]: ''
                }))
            }
        } else if (e.target.name === 'LabPercentage' || e.target.name === 'PharmacyPercentage') {

            if (/^\d*$/.test(e.target.value) && e.target.value.length <= 3) {
                setFormData(prevVal => ({
                    ...prevVal,
                    [e.target.name]: parseInt(e.target.value)
                }));
            }
        } else {
            setFormData(preVal => ({
                ...preVal, [e.target.name]: e.target.value
            }))
            if (e.target.value.length > 0) {
                setFormErrors(preVal => ({
                    ...preVal, [e.target.name]: ''
                }))
            }
        }
    };

    const formateDatabaseDatetime = (inp) => {
        const date = new Date(inp);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };

    const onChangeDateTime = (e) => {
        const dateStr = e.toString();

        const date = formateDatabaseDatetime(dateStr.slice(0, 24));

        if (date.length > 0) {
            setFormErrors(preVal => ({
                ...preVal, DateAndTime: ''
            }))
        }

        setFormData(preVal => ({
            ...preVal, DateAndTime: date
        }))
    };

    const checkErrors = () => {
        if (formData.DateAndTime === '') {

            setFormErrors(preVal => ({
                ...preVal, DateAndTime: 'Please select appointment date & time *'
            }))
        } else if (service === 'consultation' && (!formData.DoctorName || formData.DoctorName.trim() === '')) {
            setFormErrors(preVal => ({
                ...preVal, DoctorName: 'Please enter doctor name *'
            }));
        } else if (service === 'consultation' && !formData.ServiceType) {

            setFormErrors(preVal => ({
                ...preVal, ServiceType: 'Please Enter servicetype *'
            }))
        } else {
            return true;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const noError = checkErrors();

        if (noError) {
            // const payload = {
            //     name: formData.FullName,
            //     mobileNumber: formData.MobileNumber,
            //     cardNumber: formData.Cardnumber,
            //     gender: formData.Gender,
            //     dateofBirth: formateDatabaseDatetime(formData.DateofBirth),
            //     age: formData.Age,
            //     appointmentDate: formData.DateAndTime,
            //     address: formData.Address,
            //     hospitalName: hospitalName,
            //     hospitalId: hospitalId,
            //     serviceTypeId: formData.ServiceType,
            //     customerId: memberId,
            //     dependentCustomerId: formData.MemberDependentId,
            //     doctorName: formData.DoctorName,
            //     appointment: formData.Appointment,
            //     labInvestigationPercentage: formData.LabPercentage,
            //     pharmacyDiscountPercentage: formData.PharmacyPercentage,
            //     PaidAmount: formData.PaidAmount === '' ? 0 : formData.PaidAmount,
            //     TotalAmount: formData.TotalAmount === '' ? 0 : formData.TotalAmount,
            //     Status: "Approved"
            // };

            setSubmitLoading(true);

            // const responseEligible = await fetchData(`BookingConsultation/bookAppointment/add`, { ...payload });


            const status = await fetchAllData(`lambdaAPI/Status/all`);
            const bookedStatus = status.find(item => item.Value === "Booked");

            const statusAll = await fetchAllData(`lambdaAPI/Status/all`);
            const VisitedStatus = statusAll.find(item => item.Value === "Visited");



            const getServiceTypes = await fetchData("HospitalPolicies/all", { skip: 0, take: 0 });

            const HospitalPolicies = getServiceTypes.find(item => item.PoliciesType === formData.Appointment);

            const updateData = [


                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "ServiceTypeId",
                    "ColumnValue": formData.ServiceType,
                    "TableId": bookingConsultationId,

                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "HospitalPoliciesId",
                    "ColumnValue": HospitalPolicies.HospitalPoliciesId,
                    "TableId": bookingConsultationId,

                },

                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "AppointmentDate",
                    "ColumnValue": formData.DateAndTime,
                    "TableId": bookingConsultationId,

                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "Status",
                    "ColumnValue": bookedStatus.StatusId,
                    "TableId": bookingConsultationId,

                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "DoctorName",
                    "ColumnValue": formData.DoctorName,
                    "TableId": bookingConsultationId,
                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "Status",
                    "ColumnValue": VisitedStatus.StatusId,
                    "TableId": bookingConsultationId,

                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "LabInvestigationPercentage",
                    "ColumnValue": formData.LabPercentage,
                    "TableId": bookingConsultationId,
                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "PharmacyDiscountPercentage",
                    "ColumnValue": formData.PharmacyPercentage,
                    "TableId": bookingConsultationId,
                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "PaidAmount",
                    "ColumnValue": formData.PaidAmount === '' ? 0 : formData.PaidAmount,
                    "TableId": bookingConsultationId,
                },
                {
                    "TableName": "BookingConsultation",
                    "ColumnName": "TotalAmount",
                    "ColumnValue": formData.TotalAmount === '' ? 0 : formData.TotalAmount,
                    "TableId": bookingConsultationId,
                }

            ]


            const updateResponse = await fetchUpdateData("lambdaAPI/BookingConsultation/Update", updateData);

            if (updateResponse.status) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: `${service === "consultation" ? 'Free Consultation Booked'
                        : service === "lab" ? 'Lab Investigation Booked' : 'Pharmacy Discount Claimed'
                        } Successfully`,
                    details: { response: updateResponse },
                });

                setFormSuccessMessage(updateResponse.message);
                setEligibilityMessage('');
                setSubmitLoading(false);
                setIsBookingSuccess(true);

                setFormErrors({
                    DateAndTime: '', ServiceType: ''
                });

                setTimeout(() => {
                    setFormData(preVal => ({
                        ...preVal, DateAndTime: '', DoctorName: '', ServiceType: null, LabPercentage: null, PharmacyPercentage: null,
                        PaidAmount: '', TotalAmount: ''
                    }));

                    setIsformOpen(false);
                    setDisplayCoupons(false);
                    setIsBookingSuccess(false);
                    setEligibilityMessage('');
                    setFormSuccessMessage('');

                    getAvailableCoupons(formData.Cardnumber, hospitalId, memberId);
                }, 3000);
            } else if (updateResponse.message) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Failed to Book Consultation -lambdaAPI/BookingConsultation/Update',
                    payload: { ...updateData },
                    response: updateResponse,
                });

                setEligibilityMessage(updateResponse.message);
                setFormSuccessMessage('');
                setSubmitLoading(false);
            } else {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Failed to Book Consultation -lambdaAPI/BookingConsultation/Update',
                    payload: { ...updateData },
                    response: updateResponse,
                });

                setEligibilityMessage('Sorry, Your appointment haven`t booked.');
                setFormSuccessMessage('');
                setSubmitLoading(false);
            }

        } else {
            setEligibilityMessage('');
            setFormSuccessMessage('');
            setSubmitLoading(false);
        }
    };

    const handleReset = (e) => {
        e.preventDefault();

        if (service === 'pharmacy') {
            setFormData(preVal => ({
                ...preVal, HospitalName: '', Branch: '', DoctorName: '', ServiceType: null, Appointment: '',
                DiscountPercentage: 0.0, ConsultationFee: 0, LabPercentage: '', PharmacyPercentage: '', PaidAmount: '', TotalAmount: ''
            }));
        } else {
            setFormData(preVal => ({
                ...preVal, DateAndTime: '', HospitalName: '', Branch: '', DoctorName: '', ServiceType: null, Appointment: '',
                DiscountPercentage: 0.0, ConsultationFee: 0, LabPercentage: '', PharmacyPercentage: '', PaidAmount: '', TotalAmount: ''
            }));
        }

        setFormErrors({
            DateAndTime: '', HospitalName: '', Branch: '', ServiceType: '', Appointment: ''
        })
    };

    const handleCancel = () => {
        setFormData(preVal => ({
            ...preVal, DateAndTime: '', HospitalName: '', Branch: '', DoctorName: '', ServiceType: null, Appointment: '',
            DiscountPercentage: 0.0, ConsultationFee: 0, LabPercentage: null, PharmacyPercentage: null
        }));
        setFormErrors('');
        setIsformOpen(false);
        setEligibilityMessage('');
        setFormSuccessMessage('');
        setFormErrors({
            DateAndTime: '', HospitalName: '', Branch: '', ServiceType: '', Appointment: ''
        })
    };

    const fetchPreviousAppointments = async (payload) => {
        const getPrevAppointments = await fetchData('lambdaAPI/BookingConsultation/CustomerConsultationListByHospitalId', { ...payload });

        setPreviousAppointments(getPrevAppointments.data);
    };

    const bookAppointment = async (data, value) => {
        getAvailableCoupons(formData.Cardnumber, hospitalId, memberId);



        if (value === 'member') {


            await fetchPreviousAppointments({
                "skip": 0, "take": 0, "HospitalId": hospitalId,
                "MemberDependentId": null, "MemberId": memberId
            });
            setFormData((preVal) => ({
                ...preVal, FullName: data[0].FullName, MobileNumber: data[0].MobileNumber,
                Cardnumber: data[0].OHOCardNumber, Gender: data[0].Gender,
                DateofBirth: formatDate(data[0].DateofBirth), Age: calculateAge(data[0].DateofBirth),
                Address: data[0].AddressLine1, MemberDependentId: null
            }));

            const couponResponse = await fetchData("lambdaAPI/BookingConsultation/checkIndividualCoupons", {
                CustomerId: memberId,
                DependentCustomerId: null,
                hospitalId: hospitalId,
            });

            setMemberCoupons((prev) => ({
                ...prev,
                [memberId]: couponResponse.availableCoupons,
            }));


            const status = await fetchAllData(`lambdaAPI/Status/all`);
            const initiatedStatus = status.find(item => item.Value === "Initiated");

            const payload = {
                name: data[0].FullName,
                mobileNumber: data[0].MobileNumber,
                cardNumber: data[0].OHOCardNumber,
                gender: data[0].Gender,
                dateofBirth: formateDatabaseDatetime(data[0].DateofBirth),
                age: data[0].Age,
                address: data[0].AddressLine1,
                hospitalName: hospitalName,
                hospitalId: hospitalId,
                customerId: memberId,
                dependentCustomerId: null,
                status: initiatedStatus.StatusId,
            };



            const responseEligible = await fetchData(`lambdaAPI/BookingConsultation/bookAppointment/add`, { ...payload });

            if (responseEligible.status) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Booking Intiated Successfully',
                    details: { response: responseEligible },
                });


            } else if (responseEligible.message) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Failed to Book Consultation -BookingConsultation/bookAppointment/add',
                    payload: { ...payload },
                    response: responseEligible,
                });


            } else {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Failed to Book Consultation -BookingConsultation/bookAppointment/add',
                    payload: { ...payload },
                    response: responseEligible,
                });

            }

            setBookingConsultationId(responseEligible.data.bookingConsultationId || responseEligible.data[0].BookingConsultationId);

        } else {


            await fetchPreviousAppointments({
                "skip": 0, "take": 0, "HospitalId": hospitalId,
                "MemberDependentId": data.customerId, "MemberId": memberId
            });
            setFormData((preVal) => ({
                ...preVal, FullName: data.name, Gender: data.gender,
                DateofBirth: formatDate(data.dateofBirth), Age: calculateAge(data.dateofBirth),
                MemberDependentId: data.customerId
            }));

            const couponResponse = await fetchData("lambdaAPI/BookingConsultation/checkIndividualCoupons", {
                CustomerId: memberId,
                DependentCustomerId: data.customerId,
                hospitalId: hospitalId,
            });

            setDependentCoupons((prev) => ({
                ...prev,
                [data.customerId]: couponResponse.availableCoupons,
            }));


            const status = await fetchAllData(`lambdaAPI/Status/all`);
            const initiatedStatus = status.find(item => item.Value === "Initiated");

            const payload = {
                name: data.name,
                mobileNumber: data.MobileNumber,
                cardNumber: formData.Cardnumber,
                gender: data.gender,
                dateofBirth: formateDatabaseDatetime(data.dateofBirth),
                age: data.age,
                address: formData.Address,
                hospitalName: hospitalName,
                hospitalId: hospitalId,
                customerId: memberId,
                dependentCustomerId: data.customerId,
                status: initiatedStatus.StatusId,
            };



            const responseEligible = await fetchData(`lambdaAPI/BookingConsultation/bookAppointment/add`, { ...payload });

            if (responseEligible.status) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Booking Intiated Successfully',
                    details: { response: responseEligible },
                });


            } else if (responseEligible.message) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Failed to Book Consultation -lambdaAPI/BookingConsultation/bookAppointment/add',
                    payload: { ...payload },
                    response: responseEligible,
                });


            } else {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Failed to Book Consultation -lambdaAPI/BookingConsultation/bookAppointment/add',
                    payload: { ...payload },
                    response: responseEligible,
                });

            }


            setBookingConsultationId(responseEligible.data.bookingConsultationId || responseEligible.data[0].BookingConsultationId);


        }

        // Store the selected member type (either 'member' or 'dependent')
        setSelectedMemberType(value);

        // Set appointment date
        const currDate = formateDatabaseDatetime(new Date());
        setFormData((preVal) => ({
            ...preVal, DateAndTime: currDate
        }));

        setDisplayCoupons(true);
    };


    const goBackToLogin = () => {
        const isConfirmed = window.confirm("Are you sure, You want to go back for Member Verification?");
        if (isConfirmed) {
            sessionStorage.removeItem('memberId');
            sessionStorage.removeItem('memberTime')
            navigate('/verify', {
                replace: true,
            });
        }
    };

    const handleDownload = (policyUrl) => {
        if (policyUrl) {
            const url = `${invoiceUrl}${policyUrl}`;
            // Create an anchor element and simulate a click to download the file
            window.open(url, '_blank');
        }
    };

    const calculateTotalAmount = () => {
        const {
            consultationFee = 0,
            labInvestigationFee = 0,
            pharmacyFee = 0,
            otherCharges = 0,
            discountPercentage = 0
        } = invoiceForm;

        const total =
            +consultationFee +
            +labInvestigationFee +
            +pharmacyFee +
            +otherCharges;

        return Math.round(total - (total * (+discountPercentage / 100)));
    };


    const fetchInvoiceByConsultationId = async (app) => {
        try {

            setCustomerName(app.Name);
            setCustomerCardNumber(app.CardNumber);
            const bookingConsultationId = app.BookingConsultationId || app.BookingConsultationId;
            const response = await fetchAllData(`lambdaAPI/ConsultationInvoice/GetInvoiceByBookingConsultationId/${bookingConsultationId}`);

            if (response?.length > 0) {
                setInvoiceMap(prev => ({ ...prev, [bookingConsultationId]: true }));
                setSelectedInvoice(response[0]);
            } else {
                setInvoiceMap(prev => ({ ...prev, [bookingConsultationId]: false }));
                setSelectedInvoice(null);
            }
        } catch (error) {
            console.error('Error fetching invoice:', error);
            alert('Failed to load invoice. Please try again later.');
        }
    };

    const handleInvoiceSubmit = async () => {
        setIsSubmittingInvoice(true); // Start loading
        const total = calculateTotalAmount();



        const invoiceData = {
            ...invoiceForm,
            createdDate: new Date().toISOString(),
            totalAmount: total
        };



        try {
            const add = await fetchData("lambdaAPI/ConsultationInvoice/add", invoiceData);

            if (add) {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Invoice Submission Successful',
                    details: { response: add },
                });
                alert('Invoice submitted successfully!');

                const invoiceFileAdd = await fetchData("lambdaAPI/ConsultationInvoice/HospitalInvoice", {
                    bookingConsultationId: add.bookingConsultationId,
                });

                console.log("invoiceFileAdd", invoiceFileAdd);


            } else {
                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Invoice Submission Failed',
                    details: { response: add },
                });
                alert('Failed to submit invoice. Please try again later.');
            }

        } catch (error) {
            console.error("Invoice submission failed:", error);
        }

        setShowInvoiceForm(false);
        setFormData({});
        setIsSubmittingInvoice(false); // Stop loading
    };




    const openForm = (service) => {
        setIsformOpen(true);
        setService(service);

        if (service === 'consultation') {
            setFormData(preVal => ({
                ...preVal, DateAndTime: formateDatabaseDatetime(new Date()), Appointment: 'Free Consultation'
            }))
        } else if (service === 'lab') {
            setFormData(preVal => ({
                ...preVal, DateAndTime: formateDatabaseDatetime(new Date()), Appointment: 'Lab Investigation'
            }))
        } else {
            setFormData(preVal => ({
                ...preVal, DateAndTime: formateDatabaseDatetime(new Date()), Appointment: 'Pharmacy Discount'
            }))
        }
    };

    const closeServices = () => {
        setDisplayCoupons(false);
        setPreviousAppointments();
    };

    const toggleCardFlip = () => {
        setIsFlipped((isCurrentlyFlipped) => !isCurrentlyFlipped);
    };

    const openInvoiceForm = (appointment) => {
        setShowInvoiceForm(true);
        setInvoiceForm({
            bookingConsultationId: appointment.BookingConsultationId,
            customerId: appointment.CustomerId,
            dependentCustomerId: appointment.DependentCustomerId,
            consultationFee: '',
            labInvestigationFee: '',
            pharmacyFee: '',
            otherCharges: '',
            discountPercentage: '',
            paidAmount: null,
        });
    };

    const updateInvoiceForm = (event) => {
        const { name, value } = event.target;
        setInvoiceForm((currentForm) => ({ ...currentForm, [name]: value }));
    };

    const closeInvoiceForm = () => {
        setShowInvoiceForm(false);
    };

    return {
        amount,
        backCard,
        customerCardNumber,
        customerName,
        dependents,
        dependentCoupons,
        displayCoupons,
        eligibilityMessage,
        formData,
        formErrors,
        formSuccessMessage,
        formatDate,
        frontCard,
        hospitalImage,
        hospitalLogo,
        hospitalName,
        hospitalServices,
        invoiceForm,
        invoiceMap,
        isBookingSuccess,
        isDataFetched,
        isFlipped,
        isSubmittingInvoice,
        isValid,
        isformOpen,
        logo,
        memberCoupons,
        memberDetails,
        memberId,
        previousAppointments,
        selectedInvoice,
        selectedMemberType,
        service,
        serviceTypes,
        servicesLoading,
        showInvoiceForm,
        submitLoading,
        windowSize,
        calculateAge,
        bookAppointment,
        closeInvoiceForm,
        closeServices,
        fetchInvoiceByConsultationId,
        goBackToLogin,
        handleCancel,
        handleDownload,
        handleInvoiceSubmit,
        handleReset,
        handleSubmit,
        onChangeDateTime,
        onChangeHandler,
        openForm,
        openInvoiceForm,
        toggleCardFlip,
        updateInvoiceForm,
    };
};

export default useHomeController;
